// types.js
export const VUEXFIRE_INIT_VALUE      = 'genstore/INIT_VALUE'
export const VUEXFIRE_ARRAY_SET       = 'genstore/ARRAY_SET'
export const VUEXFIRE_ARRAY_ADD       = 'genstore/ARRAY_ADD'
export const VUEXFIRE_ARRAY_REMOVE    = 'genstore/ARRAY_REMOVE'
export const VUEXFIRE_SET             = 'genstore/SET'
// export const VUEXFIRE_SET_SYNC_STATE  = 'genstore/SET_SYNC_STATE'
// export const VUEXFIRE_OBJECT_ADD      = 'genstore/OBJECT_ADD'
// export const VUEXFIRE_OBJECT_REMOVE   = 'genstore/OBJECT_REMOVE'
// export const VUEXFIRE_OBJECT_SET      = 'genstore/OBJECT_SET'
